import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IAdWorkflow } from '@/shared/model/ad-workflow.model';
import { IRetrieveParameter } from '@/core/application-dictionary/components/DynamicWindow/dynamic-window.service';
import buildCriteriaQueryString from '@/shared/filter/filters';

const baseApiUrl = 'api/ad-workflows';
const baseApiProcessInstance = 'api/ad-workflow-process-instances';
const baseApiVuTaskAssignment = 'api/vu-task-assignments';

export default class AdWorkflowService {
  public find(id: number): Promise<IAdWorkflow> {
    return new Promise<IAdWorkflow>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(query?: IRetrieveParameter): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let queryParams = buildPaginationQueryOpts(query?.paginationQuery);

      if (query?.criteriaQuery) {
        if (queryParams.length) {
          queryParams += '&';
        }
        queryParams += buildCriteriaQueryString(query.criteriaQuery);
      }

      axios
        .get(`${baseApiUrl}?${queryParams}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public setDefaultRoute(params: { workflowId: number, recordId: number, approvalRouteId: number, serviceName: string }): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      console.log("testing")
      axios
        .post(`${baseApiProcessInstance}/set-default-route`, params)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveProcessInstances(documentNo: string, serviceName: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let queryParams = buildCriteriaQueryString([
        `documentNo.equals=${documentNo}`,
        `serviceName.equals=${serviceName}`
      ]);

      queryParams += buildPaginationQueryOpts({
        page: 0, size: 1, sort: []
      });

      axios
        .get(`${baseApiProcessInstance}?${queryParams}`)
        .then(function(res) {
          resolve(res.data.length ? res.data[0] : null);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IAdWorkflow): Promise<IAdWorkflow> {
    return new Promise<IAdWorkflow>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public saveDiagram(data: FormData) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/save-diagram`, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(res) {
          resolve(res);
        })
        .catch(function(err) {
          reject(err);
        });
    });
  }

  public getAssignedTask(login: string, processInstanceId: string) {
    return new Promise<any>((resolve, reject) => {
      let queryParams = buildCriteriaQueryString([
        `processInstanceId.equals=${processInstanceId}`,
        `candidateUser.equals=${login}`
      ]);

      queryParams += buildPaginationQueryOpts({
        page: 0, size: 1, sort: []
      });

      axios
        .get(`${baseApiVuTaskAssignment}?${queryParams}`)
        .then(function(res) {
          resolve(res.data.length ? res.data[0] : null);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public startProcess(workflowId: number, variables: Record<string, any>) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiProcessInstance}/start-process/${workflowId}`, variables)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(function(err) {
          reject(err);
        });
    });
  }

  public completeTask(taskId: string, variables: Record<string, any>) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiProcessInstance}/complete-task/${taskId}`, variables)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(function(err) {
          reject(err);
        });
    });
  }

  public update(entity: IAdWorkflow): Promise<IAdWorkflow> {
    return new Promise<IAdWorkflow>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
